import { Zap, KeyRound } from "lucide-react";

// Voice engine switch: fal.ai (Universal Key) vs direct ElevenLabs (BYOK).
export default function EngineToggle({ value, onChange, configured }) {
  return (
    <div className="space-y-2" data-testid="engine-toggle">
      <div className="inline-flex rounded-lg border border-border bg-background p-0.5 text-xs">
        <button type="button" onClick={() => onChange("fal")} data-testid="engine-fal"
          className={`px-3 py-1.5 rounded-md transition-colors ${value === "fal" ? "bg-primary text-primary-foreground font-semibold" : "text-muted-foreground hover:text-foreground"}`}>
          fal.ai · clé universelle
        </button>
        <button type="button" onClick={() => onChange("elevenlabs")} data-testid="engine-elevenlabs"
          className={`px-3 py-1.5 rounded-md transition-colors inline-flex items-center gap-1.5 ${value === "elevenlabs" ? "bg-secondary text-white font-semibold" : "text-muted-foreground hover:text-foreground"}`}>
          <Zap size={12} /> ElevenLabs direct
          {!configured && <span className="text-[9px] font-mono px-1.5 rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/30">clé requise</span>}
        </button>
      </div>
      {value === "elevenlabs" && !configured && (
        <div className="rounded-lg border border-amber-500/30 bg-amber-500/[0.07] px-3 py-2 text-xs text-amber-300 flex items-start gap-2" data-testid="elevenlabs-not-configured">
          <KeyRound size={13} className="mt-0.5 shrink-0" />
          <span>ElevenLabs n'est pas encore configuré. Créez une clé sur <span className="font-mono">elevenlabs.io/app/settings/api-keys</span> puis renseignez <span className="font-mono">ELEVENLABS_API_KEY</span> dans <span className="font-mono">backend/.env</span>. Le clonage de voix, votre bibliothèque de voix et les SFX ElevenLabs s'activeront automatiquement.</span>
        </div>
      )}
    </div>
  );
}
